import { vsingleton } from '@niknevis/vue-modules'
import RouteBase from '@niknevis/vue-modules/abstracts/RouteBase'

const ROUTE_PREFIX: string = 'admin.financial.'

@vsingleton()
export class AdminDepositRoute extends RouteBase {
  prefix = ROUTE_PREFIX + 'deposits.'

  show(depositId: number) {
    return this.ziggyRoute('show', depositId)
  }

  create() {
    return this.ziggyRoute('create')
  }

  update(depositId: number) {
    return this.ziggyRoute('update', { 'deposit': depositId, '_method': 'put' })
  }

  store() {
    return this.ziggyRoute('store')
  }

  payOff(depositId: number) {
    return this.ziggyRoute('pay_off', depositId)
  }
}
